import Page from '@/components/Page'
import { PostActionsProvider } from '@/components/Post/PostActionsContext'
import PostList from '@/components/Post/PostList'
import { getUserPostsQueryOptions } from '@/utils/fetchers/post'
import usePosts from '@/utils/hooks/usePosts'
import { prepareToRefetchListQuery } from '@/utils/list'
import { useSuspenseInfiniteQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { useCallback, useMemo } from 'react'
import UserPageTabLoading from './-components/UserPageTabLoading'

export const Route = createFileRoute('/u/$username/')({
	component: PersonalUpdatePage,
	pendingComponent: UserPageTabLoading,
})

function PersonalUpdatePage() {
	const { username } = Route.useParams()
	const { data, fetchNextPage, refetch, isFetchingNextPage } = useSuspenseInfiniteQuery(
		getUserPostsQueryOptions(username)
	)
	const postIds = useMemo(() => data.pages.flatMap((page) => page.data), [data.pages])
	const posts = usePosts(postIds)

	const refresh = useCallback(() => {
		prepareToRefetchListQuery(getUserPostsQueryOptions(username).queryKey)
		return refetch()
	}, [refetch, username])

	return (
		<Page>
			<PostActionsProvider
				value={{
					refresh,
				}}
			>
				{/* posts */}
				<PostList
					data={posts}
					isLoading={isFetchingNextPage}
					onLoadMore={async () => void (await fetchNextPage())}
				/>
			</PostActionsProvider>
		</Page>
	)
}
